import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/login/1.jpg'
import _imports_1 from '@/assets/images/logo/logo1.png'
import _imports_2 from '@/assets/images/logo/logo-dark.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xl-5 p-0" }
const _hoisted_4 = { class: "login-card login-dark login-bg" }
const _hoisted_5 = { class: "login-main" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-input position-relative" }
const _hoisted_9 = ["type"]
const _hoisted_10 = { class: "show-hide" }
const _hoisted_11 = { class: "form-group mb-0 checkbox-checked" }
const _hoisted_12 = { class: "mt-4 mb-0 text-center" }

import { ref } from "vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginValidation',
  setup(__props) {

let email = ref<string>("")
let formSubmitted = ref<boolean>(false)
let emailError = ref<boolean>(false)
let errors = ref([])
let password = ref<string>("")
let passwordError = ref<boolean>(false)
let type = ref<string>('password')
function validate() {
    formSubmitted.value = true;
    errors.value = [];
    if (email.value.length < 10 || email.value.search("@") == -1) {
        emailError.value = true;
        errors.value.push();
    } else {
        emailError.value = false;
        errors.value.push();
    }
    if (password.value.length < 7) {
        passwordError.value = true;

    } else {
        passwordError.value = false;
    }
}
function showPassword() {
    if (type.value === 'password') {
        type.value = 'text';
    } else {
        type.value = 'password';
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "col-xl-7 login_bs_validation b-center bg-size",
        style: _normalizeStyle({ backgroundImage: 'url(' + require('@/assets/images/login/1.jpg') + ')', })
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("img", {
          class: "bg-img-cover bg-center d-none",
          src: _imports_0,
          alt: "looginpage"
        }, null, -1)
      ]))], 4),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                class: "logo text-center",
                to: "/"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("img", {
                    class: "img-fluid for-light m-auto",
                    src: _imports_1,
                    alt: "looginpage"
                  }, null, -1),
                  _createElementVNode("img", {
                    class: "for-dark",
                    src: _imports_2,
                    alt: "logo"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("form", {
                class: "theme-form",
                novalidate: "",
                onSubmit: _withModifiers(validate, ["prevent"])
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "text-center" }, "Sign in to account", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-center" }, "Enter your email & password to login", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "col-form-label" }, "Email Address", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["form-control", _unref(formSubmitted) ? _unref(emailError) ? 'is-invalid' : 'is-valid' : '']),
                    id: "email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : email = $event)),
                    type: "email",
                    required: "",
                    placeholder: "Test@gmail.com"
                  }, null, 2), [
                    [_vModelText, _unref(email)]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "col-form-label" }, "Password", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass(["form-control", _unref(formSubmitted) ? _unref(passwordError) ? 'is-invalid' : 'is-valid' : '']),
                      type: _unref(type),
                      name: "login[password]",
                      required: "",
                      placeholder: "*********",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : password = $event))
                    }, null, 10, _hoisted_9), [
                      [_vModelDynamic, _unref(password)]
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_unref(type) == 'password' ? 'show' : ''),
                        onClick: showPassword
                      }, null, 2)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "form-check checkbox-solid-info" }, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      id: "solid6",
                      type: "checkbox"
                    }),
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: "solid6"
                    }, "Remember password")
                  ], -1)),
                  _createVNode(_component_router_link, {
                    class: "link",
                    to: "/authentication/forget_password"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("Forgot password?", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-end mt-3" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary btn-block w-100",
                      type: "submit"
                    }, "Sign in")
                  ], -1))
                ]),
                _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"login-social-title\"><h6>Or Sign in with </h6></div><div class=\"form-group\"><ul class=\"login-social\"><li><a href=\"https://www.linkedin.com\" target=\"_blank\"><i class=\"icon-linkedin\"></i></a></li><li><a href=\"https://twitter.com\" target=\"_blank\"><i class=\"icon-twitter\"></i></a></li><li><a href=\"https://www.facebook.com\" target=\"_blank\"><i class=\"icon-facebook\"></i></a></li><li><a href=\"https://www.instagram.com\" target=\"_blank\"><i class=\"icon-instagram\"></i></a></li></ul></div>", 2)),
                _createElementVNode("p", _hoisted_12, [
                  _cache[10] || (_cache[10] = _createTextVNode("Don't have account?", -1)),
                  _createVNode(_component_router_link, {
                    class: "ms-2",
                    to: "/auth/register"
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("Create Account", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})